/** Создаёт Date в полночь UTC из локальных компонентов даты */
export function toUTCDate(date: Date): Date {
    return new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    )
}
